// import { CanActivateFn } from '@angular/router';

// export const settingGuardGuard: CanActivateFn = (route, state) => {
//   return true;
// };
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenEncryptionService } from '../Services/token-encryption.service';

@Injectable({
	providedIn: 'root'
})

export class settingGuardGuard {
	constructor(private router: Router, private tokenEncryptionService: TokenEncryptionService) {
	}

	canActivate(
		next: ActivatedRouteSnapshot,
		state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const loggedInUser = this.tokenEncryptionService.getEncryptedItem('user');
		const loggedInUserRole = loggedInUser && loggedInUser?.role ? loggedInUser?.role : null;
		let checkUserIsManager: boolean;
		if (loggedInUserRole) {
			let managerRoleAvailable = loggedInUserRole.filter((ele) => {
				return (ele.toLowerCase().includes("manager"));
			});
			if (managerRoleAvailable.length > 0) {
				checkUserIsManager = true;
			} else {
				checkUserIsManager = false;
			}
		} else {
			checkUserIsManager = false;
		}
		if (localStorage.getItem('isAdmin') != 'true' && !checkUserIsManager) {
			// alert('unauthorize access');
			this.router.navigate(['']);
			return false;
		}
		return true;
	}
}